<template>
  <v-autocomplete
    :class="compClass"
    v-model="searchSelect"
    :loading="loading"
    :readonly="readonly"
    :search-input.sync="search"
    :items="adresasList"
    :label="label"
    :placeholder="placeholder"
    hide-details="auto"
    :return-object="returnObject"
    item-text="text"
    item-value="text"
    no-filter
    :autofocus="autofocus"
    :menu-props="{
      auto: true,
      bottom: true,
      offsetOverflow: false,
      allowOverflow: true,
    }"
  >
    <template v-slot:append-outer>
      <el-tooltip :tooltip="tooltip" autocomplete />
      <slot name="append-outer"></slot>
    </template>
    <template slot="loading">
      <v-list-item>
        <v-list-item-title>
          {{ neraDuomenu }}
        </v-list-item-title>
      </v-list-item>
    </template>
    <template slot="no-results">
      <v-list-item>
        <v-list-item-title>
          {{ neraDuomenu }}
        </v-list-item-title>
      </v-list-item>
    </template>
    <template slot="no-data">
      <v-list-item>
        <v-list-item-title>
          {{ neraDuomenu }}
        </v-list-item-title>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'ElAdresas',
  props: {
    classP: String,
    value: [String, Object],
    label: String,
    placeholder: { type: String, default: ' ' },
    returnObject: { type: Boolean, default: false },
    tooltip: String,
    counter: [Number, String],
    need: Boolean,
    required: Boolean,
    readonly: Boolean,
    autofocus: { type: Boolean, default: false },
    lazyLoad: { type: Boolean, default: false },
  },
  data() {
    return {
      search: null,
      searchResult: [],
      loading: false,
      loaded: false,
      minSymbolSearch: 3,
    }
  },
  computed: {
    noData() {
      return 'Duomenų nėra'
    },
    searchSelect: {
      get() {
        return this.value
      },
      set(elValue) {
        this.$emit('input', elValue)
      },
    },
    adresas: {
      get() {
        return this.value
      },
    },
    adresasList() {
      return this.searchResult.map(item => {
        return Object.assign({}, item)
      })
    },
    neraDuomenu() {
      return this.loading
        ? 'Kraunama...'
        : this.search && this.search.length > 0 && this.loaded
        ? 'Nėra duomenų'
        : ''
    },
    requiredClass() {
      return (this.required || this.need) && !this.readonly
        ? 'required-input'
        : ''
    },
    compClass() {
      return `${this.classP} ${this.requiredClass} labelPatch`
    },
  },
  watch: {
    search: _.debounce(function(val) {
      // if (this.loading) return
      this.loaded = false
      this.searchAdresas(val)
    }, 250),
  },
  created() {
    if (this.searchSelect) {
      this.searchAdresas(this.searchSelect)
    }
  },
  methods: {
    searchAdresas(val) {
      if (val && val.length >= this.minSymbolSearch) {
        this.loading = true

        const data = {
          adm_id: null,
          fragmentas: val,
        }

        this.$axios
          .post(`adresas/search`, data)
          .then(res => {
            this.searchResult = res.data.adresai
            if (this.lazyLoad) {
              this.addDefault(val)
            }
          })
          .catch(err => {
            window._VMA.$emit('DATA_ERROR', err.response.data.message)
          })
          .finally(() => {
            this.loading = false
            this.loaded = true
          })
      }
    },
    addDefault(val) {
      this.searchResult.push({
        text: val,
        value: val,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/elementsTheme.scss';
</style>
